import * as Sentry from "@sentry/vue";
import { UserRejectedRequestError } from "viem";


/**
 * Check if the error is an RPC authentication error (401 from the proxy).
 * These are handled by the rpc-auth plugin (logout + notification)
 * and should not produce error notifications or Sentry events.
 */
const isRpcAuthError = (error: any): boolean => {
  const message = error?.message || "";
  return message.includes("Status: 401")
    && (message.includes("/orpc/") || message.includes("/rpc/"));
};


export default defineNuxtPlugin((nuxtApp) => {

  // Handle app-level errors
  nuxtApp.hook("app:error", (error) => {
    if (error instanceof UserRejectedRequestError) return;
    if (isRpcAuthError(error)) return;
    if (isTooManyRequestsError(error)) return;
    eventBus.emit("error", error);
    Sentry.captureException(error);
    console.error(error);
    showErrorNotification(
      "Application error. Please refresh the page.",
      10000
    );
  });

  // Set Vue's global error handler
  nuxtApp.vueApp.config.errorHandler = (error: any, instance, info) => {
    if (error instanceof UserRejectedRequestError) return;
    if (isRpcAuthError(error)) return;
    if (isTooManyRequestsError(error)) return;
    eventBus.emit("error", error);
    Sentry.captureException(error, { extra: { instance, info } });
    console.error(error);
    showErrorNotification(
      "An unexpected error occurred. Please try again later.",
      10000
    );
  };
});
